module.exports = __webpack_public_path__ + "static/video-0cd04d46f3efcf35b101b48fc11468bd.mp4";